"use client";

import Link from "next/link";
import type { ComponentProps, MouseEvent } from "react";
import {
  classifyLiveToolPath,
  toolLoadNavigationPrefetch,
} from "@/lib/performance/tool-load-timing";
import { useNavigationLoading } from "./navigation-loading-context";
import { useToolLoadNavPrefetchAttestation } from "./use-tool-load-nav-prefetch-attestation";

export function ToolNavigationLink({ onClick, ...props }: ComponentProps<typeof Link>) {
  const { startNavigation } = useNavigationLoading();
  const prefetch = props.prefetch ?? toolLoadNavigationPrefetch();
  const navigationPrefetchAttestation = useToolLoadNavPrefetchAttestation(prefetch);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      typeof props.href !== "string"
    ) {
      return;
    }
    if (classifyLiveToolPath(props.href)) {
      startNavigation(props.href);
    }
  };

  return (
    <Link
      {...props}
      prefetch={prefetch}
      data-tool-nav-prefetch={navigationPrefetchAttestation}
      onClick={handleClick}
    />
  );
}
